module.exports = __webpack_public_path__ + "img/1.22040c4e.jpg";